import { useCallback } from 'react'
import { useFormikContext } from 'formik'
import ClassNames from 'classnames'

import l10n from '../../i18n/I18N'
import { formatCurrencyAmount, getCurrencyConfigForWalletId, getThemeImageUrl } from '../../../services/utils'
import { config } from '../../Init/Init'
import { CryptoPaymentInput } from '../CryptoPaymentFormElements/CryptoPaymentInput'
import { depositFormFields, formFieldPlaceholders } from '../cryptoPaymentConstants'
import { useCasinoStore, usePlayerStore } from '../../../services/store'

import classes from './styles/cryptoPaymentDepositInfo.module.scss'

export const CryptoPaymentDepositInfo = ({ onCoinsAmountChange, updatedSectionName }) => {
  const playerStore = usePlayerStore()
  const playerWallets = playerStore.use.playerWallets()

  const casinoStore = useCasinoStore()
  const casinoCoinsToFiatRate = casinoStore.use.casinoCoinsToFiatRate()

  const { values } = useFormikContext()
  const currencyConfig = getCurrencyConfigForWalletId(playerWallets, config.gcWalletId)

  const getFormatedCurrencyAmount = useCallback(
    (currencyType, value = values[depositFormFields.coinsAmount]) => {
      const amountValue = Number(value.replace(/,/g, ''))

      if (isNaN(amountValue) || amountValue <= 0) return formatCurrencyAmount(0, currencyType)

      let amount = 0

      if (currencyType === 'GC') {
        amount = amountValue
      } else if (casinoCoinsToFiatRate.toCoins.GC) {
        amount = amountValue / casinoCoinsToFiatRate.toCoins.GC
      }

      return formatCurrencyAmount(amount, currencyType)
    },
    [values]
  )

  const sectionClassName = ClassNames(classes.cryptoPaymentDepositInfo__section, {
    [classes.cryptoPaymentDepositInfo__section_active]: updatedSectionName === depositFormFields.coinsAmount
  })

  return (
    <div className={sectionClassName}>
      <div className={classes.cryptoPaymentDepositInfo__descriptionSection}>
        <img
          src={getThemeImageUrl(classes.cryptoPaymentErrorIcon)}
          alt={l10n.t['icons.tooltipErrorAlt']}
          className={classes.cryptoPaymentDepositInfo__errorIcon}
        />
        <div className={classes.cryptoPaymentDepositInfo__descriptionContent}>
          {l10n.t['cryptopayment.deposit.description']}
        </div>
      </div>
      <CryptoPaymentInput
        className={classes.cryptoPaymentDepositInfo__coinsAmountInput}
        placeholder={formFieldPlaceholders.numeric}
        name={depositFormFields.coinsAmount}
        label={l10n.t['cryptopayment.deposit.gcAmount']}
        afterInput={currencyConfig.currencyName}
        onChange={value => onCoinsAmountChange(value, depositFormFields.cryptoAmount)}
        format={value => getFormatedCurrencyAmount('GC', value)}
      />
      <div className={classes.cryptoPaymentDepositInfo__receiveLabel}>
        {l10n.t['cryptopayment.redeem.receive.label']}
      </div>
      <div className={classes.cryptoPaymentDepositInfo__coinsAmount}>
        <img
          src={getThemeImageUrl(classes.cryptoPaymentGameIcon)}
          alt={l10n.t['currency.GC']}
          className={classes.cryptoPaymentDepositInfo__coinIcon}
        />
        <span>
          {l10n.t['currency.GC']}&nbsp;
          {getFormatedCurrencyAmount('GC')}
        </span>
      </div>
      <div className={classes.cryptoPaymentDepositInfo__coinsAmount}>
        <span className={classes.cryptoPaymentDepositInfo__coinsAmountFree}>
          {l10n.t['cryptopayment.deposit.plusFree']}
        </span>
        &nbsp;
        <img
          src={getThemeImageUrl(classes.cryptoPaymentSweepsIcon)}
          alt={l10n.t['currency.SC']}
          className={classes.cryptoPaymentDepositInfo__coinIcon}
        />
        <span>
          {l10n.t['currency.SC']}&nbsp;
          {getFormatedCurrencyAmount('SC')}
        </span>
      </div>
      <div className={classes.cryptoPaymentDepositInfo__separator}></div>
      <div className={classes.cryptoPaymentDepositInfo__usdEstimate}>
        <span>{l10n.t['cryptopayment.deposit.usdEstimate']}</span>
        <span>
          {config.currencySymbolMap.USD}
          {getFormatedCurrencyAmount(config.baseFiatCurrency)}
        </span>
      </div>
      <div className={classes.cryptoPaymentDepositInfo__estimationInfo}>
        {l10n.t['cryptopayment.deposit.estimation']}
      </div>
    </div>
  )
}
